import { render, staticRenderFns } from "./CustomerUniversalSearch.vue?vue&type=template&id=0ff99cdc&scoped=true"
import script from "./CustomerUniversalSearch.vue?vue&type=script&lang=js"
export * from "./CustomerUniversalSearch.vue?vue&type=script&lang=js"
import style0 from "./CustomerUniversalSearch.vue?vue&type=style&index=0&id=0ff99cdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff99cdc",
  null
  
)

export default component.exports